import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)

//视频播放器
// 全局引入
import AudioPlayer from '@liripeng/vue-audio-player'
// import '@liripeng/vue-audio-player/lib/vue-audio-player.css'

Vue.use(AudioPlayer)

import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: 'cc90febdfb49dbde44de4a4de4fa4d41',
  plugin: [
    'AMap.Heatmap',
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor'
  ],
  v: '1.4.4',
})

//import scroller from 'v-scroller'
//import 'v-scroller/dist/v-scroller.css'
//Vue.use(scroller)

import { Toast } from 'vant';
Vue.use(Toast);

//引入百度地图
import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  ak: 'x2XxK254F1vEqx7cp5h33OlUMBwPX3AA'
})

//引入mintUi插件

import Mint from 'mint-ui';
Vue.use(Mint);

import axios from 'axios'
Vue.prototype.$axios = axios

Vue.config.productionTip = false

// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole)

Vue.mixin({
  methods: {
    miXinGetImgUrl(imgUrl) {
      if (!imgUrl) return
      return imgUrl.includes('http') ? imgUrl : `${window.location.origin}${imgUrl}`
    },

    miniJump(urlParams, isBack) {
      function isWx() {
        const ua = navigator.userAgent.toLowerCase()
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          return new Promise(resolve => {
            wx.miniProgram.getEnv(function(res) {
              if (res.miniprogram) {
                resolve("mini-wx")
              } else {
                resolve("wx")
              }
            })
          })
        } else {
          return new Promise(resolve => {
            resolve("no-wx")
          })
        }
      }
    
      isWx().then(type => {
        if (type === 'mini-wx') {
          // const newType = [process.env][0]
          // let baseUrl = newType && newType.NODE_ENV === 'development' ? `http://192.168.0.44:8888/#` : `https://zxsxsj.qdszgh.cn/#`
          let baseUrl = `https://zxsxsj.qdszgh.cn/#`
          if (isBack) {
            wx.miniProgram.navigateBack(-1)
            return false
          }
          // wx.miniProgram.navigateTo({
          //   url: `/pages/secondaryPage/secondaryPage?pageUrl=${encodeURIComponent(`${baseUrl}${urlParams}`)}`
          // })
		  this.$router.push(urlParams)
        } else {
          this.$router.push(urlParams)
        }
      })
    }
  }
})

Vue.prototype.setSessionItem = function (key, newVal) {
  if (key === 'active') {
    // 创建 StorageEvent 事件
    let newStorageEvent = document.createEvent("StorageEvent")
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val)

        // 初始化 StorageEvent 事件
        newStorageEvent.initStorageEvent(
          "setItem", // 事件别名
          false,
          false,
          k,
          null,
          val,
          null,
          null
        )

        // 派发事件
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal)
  }
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
